import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { MockEditService } from '../../../mock';
import { SummaryButton, SummaryItem } from '../../../models';
import { BaseEditCreateService, BaseEditService } from '../../../services';

@Component({
  selector: 'app-tab-form-modal',
  templateUrl: './tab-form-modal.component.html',
  styleUrl: './tab-form-modal.component.scss',
})
export class TabFormModalComponent {
  @Input() header: string;
  @Input() model$: Observable<any>;
  @Input() showCopy = false;
  @Input() showSave = true;
  @Input() showBack = true;
  @Input() summaryItems: (model: any) => SummaryItem[];
  @Input() baseService: BaseEditService<any, any> | BaseEditCreateService<any, any> = new MockEditService();
  @Input() isModal = true;
  @Input() copyButtonText = $localize`Copy`;
  @Input() enableCopyButton = true;
  @Input() additionalButtons: SummaryButton[];
  @Output() copyModel = new EventEmitter<any>();
}
